module.exports = __webpack_public_path__ + "img/Free_Triple_Billboard_Mockup_2.jpg";